/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardBill200ResponseLatestStatusStatus
 */
export interface GetCardBill200ResponseLatestStatusStatus {
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200ResponseLatestStatusStatus
     */
    'status'?: GetCardBill200ResponseLatestStatusStatusStatusEnum;
}

export const GetCardBill200ResponseLatestStatusStatusStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetCardBill200ResponseLatestStatusStatusStatusEnum = typeof GetCardBill200ResponseLatestStatusStatusStatusEnum[keyof typeof GetCardBill200ResponseLatestStatusStatusStatusEnum];


